import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((muiTheme) => ({
  root: {
    inputRoot: {
      borderTopRightRadius: "0px",
      borderBottomRightRadius: "0px",
    },
    "& > *": {
      margin: muiTheme.spacing(1),
      width: muiTheme.spacing(16),
      height: muiTheme.spacing(16),
    },
    ".MuiStepConnector-lineVertical": {
      borderLeftWidth: "2px",
    },
  },
  newDesignRoot: {
    [muiTheme.breakpoints.down("sm")]: {
      marginTop: "10%",
    },
    [muiTheme.breakpoints.up("md")]: {
      width: "100%",
      position: "absolute",
      overflowX: "hidden",
      overflowY: "auto",
      top: "0px",
      bottom: "20px",
      zIndex: "2",
      left: "0px",
      right: "0px",
      // padding: '10px',
      backgroundColor: "#f6f6f6",
    },
  },
  taxiPadding: {
    [muiTheme.breakpoints.down("sm")]: {
      padding: "4px",
    },
    [muiTheme.breakpoints.up("md")]: {
      padding: "12px",
    },
  },
  formHead: {
    backgroundColor: "#f9fafb",
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  formContent: {
    [muiTheme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
  paper: {
    width: "400px",
    maxWidth: "400px",
    height: "85vh",
    borderRadius: "2px",
    overflow: "hidden",
  },
  countryCode: {
    position: "absolute",
    width: "376px",
    maxWidth: "400px",
    height: "40invh",
    borderRadius: "2px",
    overflow: "hidden",
  },
  searchResult: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "6px",
    justifyContent: "center",
    marginBottom: "8px",
    cursor: "pointer",
    backgroundColor: "#f9fafb",
    "&:hover": {
      backgroundColor: "#e8eced",
    },
  },
  cardPaper: {
    height: "180px",
    backgroundColor: "#f9fafb",
    padding: "6px",
    overflow: "hidden",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#abe1d9",
    },
  },
  cardPaperBackground: {
    backgroundColor: "#f9fafb",
  },
  cardPaperInvertBackground: {
    backgroundColor: "#f9fafb",
    "&:hover": {
      backgroundColor: "#e8eced",
    },
  },
  activeBox: (props) => ({
    backgroundColor: props.companyTheme?.primaryColorCode || '#000',
    color: 'white',
    '&:hover': {
      backgroundColor: props.companyTheme?.primaryColorCode || '#000',
    },
  }),

  cardSubscription: (props) => ({
    backgroundColor: 'white',
    width: '120px',
    height: '100px',
    display: 'flex',
    color: props.companyTheme?.primaryColorCode,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '8px',
    // border: `2px solid ${props.companyTheme?.secondary}`,
    cursor: 'pointer',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: props.companyTheme?.secondaryColorCode,
      color: props.companyTheme?.primaryColorCode,
    },
  }),

  activePlan: (props) => ({
    backgroundColor: props.companyTheme?.primaryColorCode,
    color: "white",
    width: "120px",
    height: "100px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "8px",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      backgroundColor: props.companyTheme?.primaryColorCode || '#000',
    },
  }),

  vehicleRequestButton: (props) => ({
    width: '100%',
    backgroundColor: props.companyTheme?.primaryColorCode || 'black',
    borderRadius: '2px',
    padding: muiTheme.spacing(1),
    '&:hover': {
      backgroundColor: props.companyTheme?.hover,
    },
  }),
  headingBox: {
    padding: muiTheme.spacing(1, 3),
    backgroundColor: "#212121",
    color: "#f9fafb",
  },
  margin: {
    width: "90%",
    backgroundColor: "#f6f6f6",
    display: "flex",
    margin: "0 auto",
    marginTop: "20px",
    height: "50px",
  },
  searchHeading: {
    padding: muiTheme.spacing(5, 3),
    color: "#f9fafb",
  },
  fromStepper: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#343434",
    },
  },
  searchContainerMain: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "400px",
    height: "400px",
    width: "100%",
    overflowX: "hidden",
  },
  searchContainer: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "270px",
    height: "270px",
    width: "100%",
    overflowX: "hidden",
  },
  vehicleDisplayContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f9fafb",
    width: "100%",
    overflowX: "hidden",
    paddingBottom: "107px",
  },
  vehicleDisplayContainerGrid: {
    display: "flex",
    overflowX: "hidden",
    padding: "14px",
    width: "37%",
  },
  vehicleDetailContainerGrid: {
    paddingBottom: "150px",
    padding: "24px",
  },
  searchResultIcon: {
    display: "flex",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  searchResultDetailIcon: {
    display: "flex",
    justifyContent: "center",
    paddingLeft: "24px",
    minHeight: "300px",
    height: "300px",
    paddingRight: "24px",
  },
  ResultIcon: {
    backgroundColor: "lightgrey",
    padding: "12px",
    width: "20px",
    height: "20px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100px",
    display: "flex",
    flexDirection: "column",
  },
  searchResultData: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
    paddingRight: "20px",
  },
  searchResultDataPrice: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
    paddingRight: "20px",
    marginBottom: "8px",
    textAlign: "right",
  },
  resultHeading: {
    fontWeight: "bold",
    fontSize: "18px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  vehicleSelectHeader: {
    fontWeight: "bold",
    fontSize: "18px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  resultSub: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontWeight: "normal",
    fontSize: "14px",
  },
  resultSubTime: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontWeight: "normal",
    fontSize: "12px",
    marginBottom: "8px",
  },
  imgClass: {
    width: "70px",
    height: "70px",
  },
  vehicleRequest: {
    backgroundColor: "#f9fafb",
    borderTop: "1px solid grey",
    padding: muiTheme.spacing(2),
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
  },
  vehicleRequestButton: ({ companyTheme }) => ({
    width: "100%",
    backgroundColor: "black",
    borderRadius: "2px",
    padding: muiTheme.spacing(1),
    "&:hover": {
      backgroundColor: companyTheme?.primaryColorCode,
    },
  }),
  paymentTypeBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: muiTheme.spacing(0, 0, 1, 0),
  },
  paymentType: {
    display: "flex",
    flexDirection: "row",
  },
  icon: {
    color: muiTheme.palette.text.secondary,
    marginRight: muiTheme.spacing(2),
  },
  hover: {
    "&:hover": {
      backgroundColor: "#343434",
    },
  },
  textFiledAddress: {
    ".MuiOutlinedInput-root": {
      borderRadius: "0px",
    },
  },
}));